import axios from 'axios';

const getCfopsPage = params => axios.get('cfops/', {
  params,
});

export default {
  getCfopsPage,
};
